import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-1 gap-4 p-4 border border-solid border-gray-300 bg-white rounded-lg" }
const _hoisted_2 = { class: "flex flex-col gap-4" }
const _hoisted_3 = { class: "flex flex-wrap gap-2 justify-between items-center" }
const _hoisted_4 = { class: "flex flex-wrap gap-2 justify-between items-center" }
const _hoisted_5 = { class: "flex flex-wrap gap-2 justify-between items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseLabel = _resolveComponent("BaseLabel")!
  const _component_BaseSearchableDropdown = _resolveComponent("BaseSearchableDropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex flex-col pb-3" }, [
      _createElementVNode("span", { class: "text-gray-800 font-sans text-lg font-semibold leading-6 tracking-tight" }, "Contact Field Mapping")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_BaseLabel, {
          forAttr: "firstName",
          text: "First Name",
          class: "text-gray-600 font-sans text-sm font-medium leading-5",
          required: ""
        }),
        _createVNode(_component_BaseSearchableDropdown, {
          modelValue: _ctx.localFirstName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localFirstName) = $event)),
          options: _ctx.contactMappingFields.map((field) => field.label),
          placeholder: "Select",
          class: "w-32 md:w-64"
        }, null, 8, ["modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_BaseLabel, {
          forAttr: "lastName",
          text: "Last Name",
          class: "text-gray-600 font-sans text-sm font-medium leading-5",
          required: ""
        }),
        _createVNode(_component_BaseSearchableDropdown, {
          modelValue: _ctx.localLastName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localLastName) = $event)),
          options: _ctx.contactMappingFields.map((field) => field.label),
          placeholder: "Select",
          class: "w-32 md:w-64"
        }, null, 8, ["modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_BaseLabel, {
          forAttr: "title",
          text: "Title",
          class: "text-gray-600 font-sans text-sm font-medium leading-5",
          required: ""
        }),
        _createVNode(_component_BaseSearchableDropdown, {
          modelValue: _ctx.localTitle,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localTitle) = $event)),
          options: _ctx.contactMappingFields.map((field) => field.label),
          placeholder: "Select",
          class: "w-32 md:w-64"
        }, null, 8, ["modelValue", "options"])
      ])
    ])
  ]))
}